import { useState } from 'react'
import { Outlet } from 'react-router-dom'

import { Box, BoxList, Button, Text } from '@factorialco/deprecated-design-system'
import {
  type ExternalUsersExternalsPageItemFragment,
  ExternalUsersExternalsPageQueryDocument,
} from 'generated/resources/graphql'

import { Panes } from 'modules/core/components/Panes'
import { PanesPad } from 'modules/core/components/PanesPad'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import EditUserModal from 'modules/external_users/components/EditUserModal'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import Item from './Item'

const Externals = () => {
  const [isNewUserModalOpen, setIsNewUserModalOpen] = useState(false)
  const { data, loading, error, refetch } = useQuery(ExternalUsersExternalsPageQueryDocument)

  const externalAccesses: ExternalUsersExternalsPageItemFragment[] = data?.apiCore.accesses ?? []
  const canCreate = data?.authentication._policies.accessCreateExternal.can || false

  function renderList() {
    if (!externalAccesses.length)
      return (
        <Box
          background="grey000White"
          flexDirection="row"
          justifyContent="center"
          width="full"
          padding="s32"
        >
          <Text.Normal weight="medium">{i18n.t('settings.external_users.no_users')}</Text.Normal>
        </Box>
      )

    return (
      <BoxList>
        {externalAccesses.map((user) => (
          <Item key={user.id} user={user} />
        ))}
      </BoxList>
    )
  }

  return (
    <ResponsivePage.Body
      loading={loading}
      error={error}
      variant="narrow"
      widget={
        <Button iconName="add" onClick={() => setIsNewUserModalOpen(true)} disabled={!canCreate}>
          {i18n.t('settings.external_users.actions.new_user.title')}
        </Button>
      }
    >
      {isNewUserModalOpen && (
        <EditUserModal
          onClose={() => {
            setIsNewUserModalOpen(false)
            refetch()
          }}
        />
      )}
      <Panes direction="vertical">
        <PanesPad>{renderList()}</PanesPad>
        <Outlet />
      </Panes>
    </ResponsivePage.Body>
  )
}

export default Externals
